import React from 'react';
export function QuotesPageV4() {
  return <div className="flex h-full min-h-screen flex-col overflow-hidden bg-[#F3F6F8]" data-id="element-12705">
      <header className="h-[72px] flex-shrink-0 border-b border-white/10 bg-[#1E3A5F]" aria-label="Quote V4 top bar" data-id="element-12706" />
      <main className="flex-1 bg-[#F3F6F8]" aria-label="Quote V4 workspace" data-id="element-12707" />
    </div>;
}